module.exports = __webpack_public_path__ + "img/snakerun4.5e649ccc.gif";